module.exports = [
  require('./to')
];


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/function/unit/index.js
// module id = 1458
// module chunks = 0